<template>
  <div class="pb-20 pt-36">
    <!-- SEO Meta Tags -->
    <PageSEO
      title="About Us - Meet the Vedware Team"
      description="Learn about our experienced team of web developers and digital solution experts. 20+ years of combined experience in delivering exceptional projects for clients worldwide."
      :keywords="['about us', 'team', 'web developers', 'digital experts', 'experience', 'company']"
      url="https://vedware.com/about"
    />

    <AboutTeam class="container mx-auto" />

    <AboutCounter />

    <AboutClients class="container mx-auto" />
  </div>
</template>

<script setup lang="ts">
import { definePageMeta } from '#imports'
import AboutClients from '~/components/About/AboutClients.vue'
import AboutCounter from '~/components/About/AboutCounter.vue'
import AboutTeam from '~/components/About/AboutTeam.vue'
import PageSEO from '~/components/Shared/PageSEO.vue'

definePageMeta({
  scrollToTop: true,
})
</script>
